<template>
  <div>
    <img
      class="size"
      :src="src"
      :style="{
        width: `${size}px`,
        height: `${size}px`,
        lineHeight: `${size}px`,
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    src: { Type: String },
    size: { type: Number },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.size {
  object-fit: cover;
  vertical-align: middle;
  max-width: 100%;
  height: 100%;
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/avatar.vue